<template>
    <div class="bg-white px-7 py-3 rounded text-gray">
        <div class="mb-8">
            <checkbox :model-value="allSelected" class="regular text-sm" @update:model-value="onSelectAll">Выбрать все</checkbox>
        </div>
        <div v-for="item in userSchedules">
            <checkbox v-model="item.checked" class="regular text-sm" @change="onClick">
                <User class="relative bottom-2" :first-name="item.user.first_name" :last-name="item.user.last_name" :avatar="item.user.avatar" />
            </checkbox>
        </div>
       
    </div>
</template>

<script setup lang="ts">
import { Schedule } from '@/types';
import User from '../User.vue';
import { computed, ref } from 'vue';

interface Props {
    schedules: Schedule[]
}

const props = defineProps<Props>()

const emit = defineEmits(['selected'])

const allSelected = ref(true)

const userSchedules = computed(() => props.schedules.map(item => {
    return { checked: true, id: item.id, user: item.user, shifts: item.shifts}
}))

const onClick = () => {
    const selectedSchedules = userSchedules.value.filter(item => item.checked)
    emit('selected', selectedSchedules)
    allSelected.value = selectedSchedules.length === userSchedules.value.length
}

const onSelectAll = (isSelected: boolean) => {
    allSelected.value = isSelected
    userSchedules.value.forEach(item => item.checked = isSelected)
    emit('selected', userSchedules.value.filter(item => item.checked))
}
</script>

<style scoped>

</style>
